import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataTablesResponse} from '../models/dataTables-response';
import {webServiceConfig} from '../config/web-service.config';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class OrderService {

    constructor(private http: HttpClient) {
    }

    getActiveDatatable(dataTablesParameters): Observable<any> {
        return this.http.post<DataTablesResponse>(`${webServiceConfig.webServiceUrl}orders/active/datatable`, dataTablesParameters, {})
            .pipe(map(response => {
                return response;
            }));
    }

    getById(orderId: number): Observable<any> {
        return this.http.get(`${webServiceConfig.webServiceUrl}orders/${orderId}`).pipe(map(response => {
            return response;
        }));
    }

    delivered(orderId: number): Observable<any> {
        return this.http.patch(`${webServiceConfig.webServiceUrl}orders/delivered/${orderId}`, {}).pipe(map(response => {
            return response;
        }));
    }

    statusOrder(orderId: number, status: number): Observable<any> {
        return this.http.patch(`${webServiceConfig.webServiceUrl}orders/status/${orderId}/${status}`, {}).pipe(map(response => {
            return response;
        }));
    }
}
